console.log('javascripts');

document.addEventListener('DOMContentLoaded', function () {
  document.querySelector('.dn-burger').addEventListener('click', function () {
    const body = document.body;

    if (!body.classList.contains('dn-mobile-menu-active')) {
      body.classList.add('dn-mobile-menu-active');
      body.classList.remove('dn-mobile-menu-inactive');
    } else {
      body.classList.remove('dn-mobile-menu-active');
      body.classList.add('dn-mobile-menu-inactive');
    }
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth >= 992) {
      document.body.classList.remove('dn-mobile-menu-active');
    }
  });

  const header = document.querySelector('.dn-header');

  window.addEventListener('scroll', function () {
    if (window.scrollY > 30) {
      //header.classList.add('dn-header-scrolled');
    } else {
      //header.classList.remove('dn-header-scrolled');
    }
  });
});

// Mobile Button
const burgerButton = document.querySelector('.dn-burger-container');
const mobileMenu = document.getElementById('dn-mobile-menu');

burgerButton.addEventListener('click', () => {
  const expanded = burgerButton.getAttribute('aria-expanded') === 'true';
  burgerButton.setAttribute('aria-expanded', String(!expanded));
});

// Accordion
document.addEventListener('DOMContentLoaded', () => {
  const headers = document.querySelectorAll('.dn-accordion-header');

  headers.forEach(header => {
    header.addEventListener('click', () => {
      const item = header.closest('.dn-accordion-item');
      const content = item.querySelector('.dn-accordion-content');

      if (item.classList.contains('active')) {
        // Schließen
        content.style.height = content.scrollHeight + 'px';
        requestAnimationFrame(() => {
          content.style.height = '0';
          content.style.opacity = 0;
        });
        item.classList.remove('active');
      } else {
        // Öffnen
        item.classList.add('active');
        content.style.height = content.scrollHeight + 'px';
        content.style.opacity = 1;

        content.addEventListener('transitionend', function handler() {
          content.style.height = 'auto'; // Danach flexibel
          content.removeEventListener('transitionend', handler);
        });
      }
    });
  });
});

// Swiper
var swiper = new Swiper(".dn-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    spaceBetween: 10,
    centeredSlides: false,
    watchSlidesProgress: true,
    fraction: true,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
});

// Greensock
gsap.registerPlugin(ScrollTrigger);

const initParallax = () => {
  const el = document.querySelector('.dn-block-parallax');
  if (!el) {
    // Try again after a short delay if element hasn't appeared yet
    setTimeout(initParallax, 100);
    return;
  }

  gsap.to(el, {
    y: -100,
    ease: "none",
    scrollTrigger: {
      trigger: el,
      start: 'top bottom',
      scrub: true
    }
  });
};

initParallax();

/* Standardwerte */
const animationDefaults = {
  type: "fade",
  duration: 0.8,
  delay: 0.2,
  ease: "sine.out",
  distance: 0, // px für die Slide-Richtung
  start: "top 85%" // ScrollTrigger-Startpunkt
};

/* Mapping der Richtung → From-Werte */
function getFromValues(type, distance) {
  switch (type) {
    case "fade-up":   return { y:  distance, opacity: 0 };
    case "fade-down": return { y: -distance, opacity: 0 };
    case "fade-left": return { x:  distance, opacity: 0 };
    case "fade-right":return { x: -distance, opacity: 0 };
    case "fade":      return { opacity: 0 };
    default:          return { opacity: 0 };
  }
}

/* Hilfsfunktion: Zahl aus data-Attr parsen, 0 zulassen */
function num(val, fallback) {
  const n = Number(val);
  return Number.isFinite(n) ? n : fallback;
}

document.addEventListener("DOMContentLoaded", () => {
  // Respektiere reduzierte Bewegung
  const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  document.querySelectorAll("[data-animate]").forEach(el => {
    const type     = el.dataset.animate || animationDefaults.type;
    const duration = num(el.dataset.animateDuration, animationDefaults.duration);
    const delay    = num(el.dataset.animateDelay, animationDefaults.delay);
    const ease     = el.dataset.animateEase || animationDefaults.ease;
    const distance = num(el.dataset.animateDistance, animationDefaults.distance);
    const start    = el.dataset.animateStart || animationDefaults.start;

    const fromVars = getFromValues(type, distance);
    const toVars   = { opacity: 1, x: 0, y: 0, duration, delay, ease };

    if (prefersReduced) {
      // Ohne Animation sofort sichtbar
      gsap.set(el, { opacity: 1, x: 0, y: 0 });
      return;
    }

    gsap.fromTo(el, fromVars, {
      ...toVars,
      scrollTrigger: {
        trigger: el,
        start,      // z. B. "top 85%"
        once: true, // nur einmal abspielen
      }
    });
  });

  // Nach Bild-/Font-Ladevorgängen sicherheitshalber layout neu berechnen
  window.addEventListener("load", () => ScrollTrigger.refresh());
});

// Hero fullscreen
/*
(function () {
  let currentHeight = 0;
  let currentHeightLazy = 0;

  // Erkennt mobile Geräte (wegen Adressleisten-Verhalten)
  const isMobile = typeof window.orientation !== "undefined";

  // Funktion zum Berechnen & Setzen der Höhe
  function updateScreenHeight() {
    // Tatsächliche sichtbare Höhe des Fensters
    const measuredHeight = Math.min(document.documentElement.clientHeight, window.innerHeight);

    // Wenn sich die Höhe wirklich geändert hat
    if (measuredHeight !== currentHeight) {
      currentHeight = measuredHeight;

      // Sofort aktualisieren (direkt reaktiv)
      document.documentElement.style.setProperty("--screenheight", `${currentHeight}px`);

      // "Lazy"-Wert nur setzen, wenn sich die Höhe stark verändert hat
      const diffRatio = Math.abs((currentHeightLazy - currentHeight) / (currentHeightLazy || currentHeight));
      if (!currentHeightLazy || !isMobile || diffRatio >= 0.2) {
        currentHeightLazy = currentHeight;
        document.documentElement.style.setProperty("--screenheightLazy", `${currentHeightLazy}px`);
      }
    }
  }

  // Beim Start einmal ausführen
  updateScreenHeight();

  // Nur gelegentlich aktualisieren (debounce gegen Resize-Flut)
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateScreenHeight, 10);
  });

  // Bei Orientierungwechsel (z. B. Handy drehen)
  window.addEventListener("orientationchange", updateScreenHeight);
})();
*/
/*
function setFullscreenHeight() {
    const vh = ååwindow.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
  setFullscreenHeight();
  
  let currentOrientation = window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
  
  window.addEventListener('resize', () => {
    const newOrientation = window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
  
    if (newOrientation !== currentOrientation) {
      currentOrientation = newOrientation;
      setFullscreenHeight();
    }
  });

document.addEventListener('DOMContentLoaded', function () {
  document.querySelector('.dn-burger').addEventListener('click', function () {
    const body = document.body;

    if (!body.classList.contains('dn-mobile-menu-active')) {
      body.classList.add('dn-mobile-menu-active');
      body.classList.remove('dn-mobile-menu-inactive');
    } else {
      body.classList.remove('dn-mobile-menu-active');
      body.classList.add('dn-mobile-menu-inactive');
    }
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth >= 992) {
      document.body.classList.remove('dn-mobile-menu-active');
    }
  });

  const header = document.querySelector('.dn-header');

  window.addEventListener('scroll', function () {
    if (window.scrollY > 30) {
      header.classList.add('dn-header-scrolled');
    } else {
      header.classList.remove('dn-header-scrolled');
    }
  });
});

// Header hover
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.dn-header');

  header.addEventListener('mouseenter', () => {
    //header.classList.add('dn-header-scrolled');
  });

  header.addEventListener('mouseleave', () => {
    //header.classList.remove('dn-header-scrolled');
  });
});

// Submenu
document.addEventListener('DOMContentLoaded', () => {
  const icons = document.querySelectorAll('.dn-submenu-icon');

  icons.forEach(icon => {
    icon.addEventListener('click', e => {
      e.preventDefault();
      const parentLi = icon.closest('.dn-main-nav-li');
      const submenu = parentLi.querySelector('.dn-sub-nav-ul');

      if (parentLi.classList.contains('submenu-open')) {
        // Zuklappen
        submenu.style.height = submenu.scrollHeight + 'px'; // Startwert
        requestAnimationFrame(() => {
          submenu.style.height = '0';
          submenu.style.opacity = 0;
        });
        submenu.addEventListener('transitionend', function handler() {
          submenu.style.height = '';
          submenu.removeEventListener('transitionend', handler);
        });
        parentLi.classList.remove('submenu-open');
      } else {
        // Aufklappen
        parentLi.classList.add('submenu-open');
        submenu.style.height = submenu.scrollHeight + 'px';
        submenu.style.opacity = 1;

        submenu.addEventListener('transitionend', function handler() {
          submenu.style.height = 'auto'; // Danach dynamisch
          submenu.removeEventListener('transitionend', handler);
        });
      }
    });
  });
});

// Accordion
document.addEventListener('DOMContentLoaded', () => {
  const headers = document.querySelectorAll('.dn-accordion-header');

  headers.forEach(header => {
    header.addEventListener('click', () => {
      const item = header.closest('.dn-accordion-item');
      const content = item.querySelector('.dn-accordion-content');

      if (item.classList.contains('active')) {
        // Schließen
        content.style.height = content.scrollHeight + 'px';
        requestAnimationFrame(() => {
          content.style.height = '0';
          content.style.opacity = 0;
        });
        item.classList.remove('active');
      } else {
        // Öffnen
        item.classList.add('active');
        content.style.height = content.scrollHeight + 'px';
        content.style.opacity = 1;

        content.addEventListener('transitionend', function handler() {
          content.style.height = 'auto'; // Danach flexibel
          content.removeEventListener('transitionend', handler);
        });
      }
    });
  });
});

// Countdown
  document.addEventListener("DOMContentLoaded", function () {
    // Prüfen, ob Countdown-Container vorhanden ist
    const countdownEl = document.getElementById("countdown");
    if (!countdownEl) return; // Script sofort abbrechen, wenn kein Countdown da

    const daysEl = document.getElementById("countdown_days");
    const hoursEl = document.getElementById("countdown_hours");
    const minutesEl = document.getElementById("countdown_minutes");
    const secondsEl = document.getElementById("countdown_seconds");

    // Zieldatum festlegen (Jahr, Monat-1, Tag, Stunde, Minute, Sekunde)
    const targetDate = new Date(2026, 6, 4, 0, 0, 0); // 30. August 2025 Mitternacht

    function updateCountdown() {
      const now = new Date().getTime();
      const distance = targetDate.getTime() - now;

      // Wenn Zielzeit erreicht oder überschritten: alles auf 0
      if (distance <= 0) {
        daysEl.textContent = 0;
        hoursEl.textContent = 0;
        minutesEl.textContent = 0;
        secondsEl.textContent = 0;
        return false; // signalisiert: Countdown fertig
      }

      // Berechnungen für Tage, Stunden, Minuten, Sekunden
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Werte einsetzen
      daysEl.textContent = days;
      hoursEl.textContent = hours;
      minutesEl.textContent = minutes;
      secondsEl.textContent = seconds;

      return true; // signalisiert: Countdown läuft noch
    }

    // Direkt beim Laden einmal ausführen
    updateCountdown();

    // Dann jede Sekunde aktualisieren – nur solange Countdown läuft
    const timer = setInterval(() => {
      if (!updateCountdown()) clearInterval(timer);
    }, 1000);
  });

// Formular
document.querySelectorAll('.dn-custom-file input[type="file"]').forEach(input => {
  input.addEventListener('change', e => {
    const fileName = input.files[0] ? input.files[0].name : 'Keine Datei';
    input.closest('.dn-custom-file').querySelector('.dn-filename').textContent = fileName;
  });
});

flatpickr(".dn-datepicker", {
  dateFormat: "Y-m-d", // Format: 2025-07-30
  altInput: true,
  altFormat: "d.m.Y",   // Format für den Nutzer: 30.07.2025
  allowInput: true
});

flatpickr(".dn-timepicker", {
  enableTime: true,
  noCalendar: true,
  dateFormat: "H:i",
  time_24hr: true
});

document.addEventListener('DOMContentLoaded', () => {
  gsap.registerPlugin(ScrollTrigger);

  const initParallax = () => {
    const el = document.querySelector('.dn-image-parallax');
    if (!el) {
      // Try again after a short delay if element hasn't appeared yet
      setTimeout(initParallax, 100);
      return;
    }

    gsap.to(el, {
      y: -100,
      ease: "none",
      scrollTrigger: {
        trigger: el,
        start: 'top bottom',
        scrub: true
      }
    });
  };

  initParallax();
});

  gsap.registerPlugin(ScrollTrigger);

  // Beispiel: Alle Blöcke mit Klasse .dn-section sollen smooth einblenden
  gsap.utils.toArray('.dn-animate').forEach(section => {
    gsap.from(section, {
      opacity: 0,
      y: 0,  // leicht nach unten versetzt starten
      duration: 1.25,
      ease: "power2.out",
      scrollTrigger: {
        trigger: section,
        start: "top 80%",  // Animation starten wenn Sektion zu 80% im Viewport ist
        toggleActions: "play none none none",
        // optional: einmal abspielen, kein Zurücksetzen
      }
    });
  });

  // Beispiel: Alle Blöcke mit Klasse .dn-section sollen smooth einblenden
  gsap.utils.toArray('.dn-block').forEach(section => {
    gsap.from(section, {
      opacity: 0,
      y: 0,  // leicht nach unten versetzt starten
      duration: 1.25,
      ease: "power2.out",
      scrollTrigger: {
        trigger: section,
        start: "top 80%",  // Animation starten wenn Sektion zu 80% im Viewport ist
        toggleActions: "play none none none",
        // optional: einmal abspielen, kein Zurücksetzen
      }
    });
  });

  Fancybox.bind("[data-fancybox]", {
  // Your custom options
});
*/